import { HookError } from 'components/ErrorBoundary';
import { getMojoContext } from 'utils/chatContext';
import { ChatContextStateType, ChatContextReducerActionType } from './types';
import { ACTIONS } from 'constants/hook';
import { QUERY_STATUS } from 'constants/query';

export const initialState: ChatContextStateType = {
  isAiContextSent: false,
  isInitWithDynamicHandRaiser: false,
  mojoContext: getMojoContext(),
  popularTopics: {
    data: undefined,
    fetchStatus: QUERY_STATUS.DEFAULT,
  },
  urlCurrentAiContext: undefined,
  urlPreviousAiContext: undefined,
};

export const chatContextReducer = (
  state: ChatContextStateType,
  action: ChatContextReducerActionType,
) => {
  switch (action.type) {
    case ACTIONS.INITIALIZE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
